import _, { remove } from 'lodash';
import classNames from 'classnames';

import React, { useContext, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography, IconButton, Grid } from '@material-ui/core';
import { ShootingContext } from 'contexts';
import RemoveCircleOutlineRoundedIcon from '@material-ui/icons/RemoveCircleOutlineRounded';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { useLanguage } from 'hooks';
import { IPackage } from 'types';
import { Shooting, ServiceOffer } from 'models';
import {
  COLOR,
  ENG,
  SHOOTING_STEPS,
  SERVICE_OFFER_CATEGORY_ICON,
  CARTE_SERVICE_OFFERS,
  SERVICE_OFFER_CATEGORY_NAME,
} from 'config/constants';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import { HvPleaseWait, HvButton } from 'components';
import { getServiceDescriptionIcon } from 'utils';
import { images } from 'assets/images';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { DoneRounded } from '@material-ui/icons';

const useStyles = makeStyles({
  stepContent: {
    position: 'relative',
    minHeight: 100,

    '& .MuiIconButton-root': {
      padding: 0,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 30,
    },
  },
  wait: {
    backgroundColor: 'transparent',
  },
  group: {
    marginBottom: 30,

    '&:last-child': {
      marginBottom: 0,
    },

    '& > h1': {
      textAlign: 'center',
    },
  },
  groupItem: {
    flex: 1,
    borderRadius: 4,
    marginBottom: 20,
    cursor: 'pointer',

    '&.Selected': {
      backgroundColor: '#1074BC0A',
    },
  },
  packageContent: {
    cursor: 'pointer',
  },
  subtitle: {
    fontFamily: 'FordAntenna-Medium',
    marginBottom: 10,
    marginTop: 10,
  },
  title: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 16,
  },
  recommendedLabel: {
    height: 24,
    color: 'white',
    fontSize: 12,
    lineHeight: '24px',
    textTransform: 'capitalize',
    borderRadius: 10,
    backgroundColor: COLOR.BLUE2,
    boxSizing: 'border-box',
    padding: '0 10px',
    marginLeft: 20,
  },
  moreInfo: {
    width: 'fit-content',
    color: COLOR.BLUE2,
    fontSize: 14,
    textDecoration: 'underline',
    marginTop: 10,
  },
  selectButton: {
    marginLeft: 30,

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  viewMore: {
    color: 'rgba(0, 0, 0, 0.54)',
    cursor: 'pointer',
  },
  selected: {
    color: '#fff',
    fontSize: '25px !important',
    backgroundColor: '#00BDF2',
    borderRadius: '50%',
    boxSizing: 'border-box',
    padding: 3,
    margin: 2.5,
  },
  editVideo: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  divider: {
    margin: '5px 0',
  },
  packagesRow: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'scroll',
    padding: '10px 10px 20px 10px',
  },
  packageColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: 20,
  },
  packageCircle: {
    display: 'flex',
    height: 80,
    width: 80,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 40,
    boxShadow: '0px 4px 15px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: 10,
    border: '2px white solid',
  },
  selectedPackageCircle: {
    display: 'flex',
    height: 80,
    width: 80,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 40,
    boxShadow: '0px 4px 15px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: 10,
    border: '2px #00bdf2 solid',
  },
  dronePackageCircleColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  packageInfoText: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 12,
  },
  bestValueContent: {
    backgroundColor: COLOR.LIGHT_BLUE,
    padding: 5,
    borderRadius: 8,
    color: COLOR.WHITE,
    maxWidth: 80,
  },
  bestValueText: {
    fontSize: '0.7rem',
    textAlign: 'center',
  },
  icon: {
    width: 20,
    height: 20,
    marginLeft: 10,
  },
  packagePhotoTitle: {
    fontSize: 15,
    fontFamily: 'FordAntenna-SemiBold',
    marginTop: 20,
  },
  packageDescriptionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    paddingRight: 10,
  },
  packageDescription: {
    '@media (max-width: 767px)': {
      fontSize: 12,
    },
  },
  none: {
    marginTop: 10,
  },
  droneIcon: {
    height: 40,
    width: 40,
    marginLeft: 8,
    marginRight: 8,
  },
  cameraIcon: {
    height: 40,
    width: 40,
    marginLeft: 10,
    marginRight: 20,
  },
  bold: {
    fontFamily: 'FordAntenna-SemiBold',
  },
  selectedPackage: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 5,
    marginTop: 5,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButton: {
    backgroundColor: COLOR.WHITE,
    color: COLOR.LIGHT_BLUE,
    borderColor: COLOR.LIGHT_BLUE,
    marginRight: 20,
    '@media (max-width: 767px)': {
      fontSize: 10,
      marginRight: 5,
      padding: 2,
    },
  },
  serviceContent: {
    borderRadius: 8,
    padding: 20,
    backgroundColor: COLOR.LIGHT_BLUE_BG,
    marginBottom: 10,
  },
  selectedServiceTitle: {
    fontSize: 16,
    fontFamily: 'FordAntenna-SemiBold',
  },
  selectedServiceContent: {
    borderRadius: 8,
    padding: 8,
    borderWidth: 1,
  },
  serviceTitleRow: {
    flexDirection: 'row',
  },
  servicePriceRow: {
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  priceRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  priceText: {
    marginRight: 10,
    fontFamily: 'FordAntenna-Medium',
    fontSize: 20,
  },
  tick: {
    position: 'absolute',
    right: 30,
    cursor: 'pointer',
  },
  serviceDivider: {
    width: 24,
    height: 24,
    borderRadius: 14,
    border: '2px #bcbbc1 solid',
  },
  categoryContent: {
    display: 'flex',
    justifyContent: 'center',
  },
  signatureButton: {
    backgroundImage: `url(${images.signature_bg})`,
    height: 100,
    backgroundSize: 'cover',
    marginBottom: 10,
  },
  selectedSignatureButton: {
    backgroundImage: `url(${images.signature_bg})`,
    height: 100,
    border: `3px ${COLOR.LIGHT_BLUE} solid`,
    backgroundSize: 'cover',
    marginBottom: 10,
  },
  shootingPackageButton: {
    backgroundImage: `url(${images.photo_package_bg})`,
    height: 100,
    backgroundSize: 'cover',
    marginBottom: 10,
  },
  selectedShootingPackageButton: {
    backgroundImage: `url(${images.photo_package_bg})`,
    height: 100,
    border: `3px ${COLOR.LIGHT_BLUE} solid`,
    backgroundSize: 'cover',
    marginBottom: 10,
  },
  packageCategoryTitle: {
    color: COLOR.WHITE,
    fontSize: 20,
    fontFamily: 'FordAntenna-SemiBold',
    position: 'absolute',
    left: 20,
    bottom: 10,
  },
  categoryTitleContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  categoryIcon: {
    width: 50,
    height: 50,
    marginRight: 10,
  },
  nextButton: {
    color: COLOR.WHITE,
    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '6px 14px',
    },
  },
  saveButton: {
    color: COLOR.WHITE,
    '@media (max-width: 767px)': {
      fontSize: 10,
      height: 30,
    },
  },
  tabs: {
    backgroundColor: COLOR.LIGHT_BLUE,
    borderRadius: 30,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 400,
    padding: 5,
    marginBottom: 10,
  },
  selectedTab: {
    backgroundColor: COLOR.WHITE,
    alignItems: 'center',
    width: '100%',
    borderRadius: 20,
    padding: 4,
    height: 32,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    '& p': {
      color: COLOR.LIGHT_BLUE,
      fontFamily: 'FordAntenna-Medium',
      fontSize: 13,
    },
  },
  tab: {
    textTransform: 'none',
    width: '100%',
    alignItems: 'center',
    borderRadius: 20,
    padding: 4,
    height: 32,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    '& p': {
      color: COLOR.WHITE,
      fontFamily: 'FordAntenna-Medium',
      fontSize: 13,
    },
  },
  tabIcon: {
    width: 40,
    height: 40,
    marginRight: 5,
  },
  photoCountRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  bigIcon: {
    width: 30,
    height: 30,
    marginRight: 10,
  },
  countText: {
    '@media (max-width: 500px)': {
      fontSize: 14,
    },
  },
  photoCount: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 20,
    '@media (max-width: 900px)': {
      fontSize: '1rem',
    },
  },
  dronePhotoCount: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 20,
    color: COLOR.WHITE,
    '@media (max-width: 900px)': {
      fontSize: '1rem',
    },
  },
  minusIconButton: {
    width: 40,
    height: 40,
    marginRight: 20,
  },
  minusIcon: {
    color: COLOR.LIGHT_BLUE,
    width: 40,
    height: 40,
  },
  plusIconButton: {
    width: 40,
    height: 40,
    marginLeft: 20,
  },
  plusIcon: {
    color: COLOR.LIGHT_BLUE,
    width: 40,
    height: 40,
  },
  circle: {
    width: 40,
    height: 40,
    borderRadius: 21,
    backgroundColor: COLOR.WHITE,
    outline: `2px ${COLOR.LIGHT_BLUE} solid`,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 60,
    zIndex: 2,
    '@media (max-width: 767px)': {
      marginLeft: 20,
    },
  },
  selectedCircle: {
    width: 40,
    height: 40,
    borderRadius: 21,
    cursor: 'pointer',
    outline: `2px ${COLOR.LIGHT_BLUE} solid`,
    backgroundColor: COLOR.LIGHT_BLUE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      color: COLOR.WHITE,
    },
    marginLeft: 60,
    zIndex: 2,
    '@media (max-width: 767px)': {
      marginLeft: 20,
    },
  },
  droneRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  line: {
    width: 'calc(100% - 60px)',
    right: 0,
    height: 2,
    backgroundColor: COLOR.LIGHT_BLUE,
    position: 'absolute',
    top: 20,
  },
  servicesCard: {
    borderRadius: 10,
    padding: '10px 20px',
    boxShadow: '0px 0px 15px 8px rgba(0, 0, 0, 0.08)',
    marginBottom: 20,
    height: '100%',
    '@media (max-width: 767px)': {
      height: 200,
    },
  },
  card: {
    height: 220,
    overflowY: 'auto',
    borderRadius: 10,
    padding: '10px 20px',
    boxShadow: '0px 3px 8px 5px rgba(0, 0, 0, 0.08)',
    marginBottom: 20,
  },
  servicesRow: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 5,
    overflowX: 'auto',
    width: '100%',
  },
  serviceCard: {
    borderRadius: 10,
    padding: 20,
    marginRight: 20,
    height: 110,
    width: 200,
    cursor: 'pointer',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'space-between',
    display: 'flex',
    flexShrink: 0,
    '& p': {
      color: COLOR.WHITE,
      zIndex: 2,
    },
    '@media (max-width: 767px)': {
      width: 130,
      height: 110,
    },
  },
  circleIcon: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: COLOR.WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  plus: {
    color: COLOR.LIGHT_BLUE,
    width: 20,
    height: 20,
  },
  servicePrice: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 14,
  },
  priceContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  originalPrice: {
    textDecoration: 'line-through',
    color: COLOR.DARK_GREY,
    marginRight: 20,
    fontFamily: 'FordAntenna-Light',
    '@media (max-width: 900px)': {
      fontSize: 11,
      marginRight: 10,
    },
  },
  pricePerPhoto: {
    fontFamily: 'FordAntenna-Light',
    '@media (max-width: 900px)': {
      fontSize: 12,
    },
  },
  shootingPriceText: {
    marginRight: 10,
    fontFamily: 'FordAntenna-Medium',
    fontSize: 20,
    '@media (max-width: 900px)': {
      fontSize: 14,
      marginRight: 0,
    },
  },
  savingText: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 16,
    '@media (max-width: 900px)': {
      fontSize: 13,
    },
  },
  savingContent: {
    borderRadius: 8,
    backgroundColor: COLOR.LIGHT_BLUE,
    color: COLOR.WHITE,
    padding: '5px 10px',
    marginLeft: 10,
    '@media (max-width: 900px)': {
      padding: 4,
    },
  },
  signatureSavingContent: {
    borderRadius: 8,
    backgroundColor: COLOR.LIGHT_BLUE,
    color: COLOR.WHITE,
    padding: '5px 10px',
    marginRight: 10,
  },
  shootingPackageRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  seasonalPriceText: {
    marginRight: 10,
    fontFamily: 'FordAntenna-Medium',
    fontSize: 20,
    '@media (max-width: 900px)': {
      fontSize: 13,
      marginRight: 0,
    },
  },
  seasonalName: {
    '@media (max-width: 900px)': {
      fontSize: 14,
    },
  },
  disabledIcon: {
    color: COLOR.GREY,
    width: 40,
    height: 40,
  },
  seasonalOptionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  selectedSeasonal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: COLOR.LIGHT_BLUE,
    borderRadius: 8,
    marginLeft: 20,
    border: `2px ${COLOR.LIGHT_BLUE} solid`,
    padding: '4px 10px',
    cursor: 'pointer',
    '& p': {
      color: COLOR.WHITE,
    },
    '@media (max-width: 500px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      width: 50,
      height: 80,
    },
  },
  seasonal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 8,
    padding: '4px 10px',
    border: `2px ${COLOR.LIGHT_BLUE} solid`,
    marginLeft: 20,
    cursor: 'pointer',
    '@media (max-width: 500px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      width: 50,
      height: 80,
    },
  },
  seasonalIcon: {
    width: 40,
    height: 40,
    marginRight: 10,
    '@media (max-width: 500px)': {
      width: 30,
      height: 30,
      margin: 'auto',
    },
  },
  seasonalText: {
    // fontSize: 14,
    '@media (max-width: 500px)': {
      fontSize: 11,
    },
  },
  examples: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.07)',
    padding: 20,
  },
  block: {
    padding: 8,
    marginBottom: 20,
    backgroundColor: COLOR.WHITE,
  },
  selectedBlock: {
    padding: 8,
    marginBottom: 20,
    border: `3px ${COLOR.LIGHT_BLUE} solid`,
    backgroundColor: COLOR.WHITE,
  },
  exampleImage: {
    width: '100%',
    height: 140,
    borderRadius: 8,
    objectFit: 'cover',
    '@media (max-width: 900px)': {
      height: 140,
    },
  },
  buttonText: {
    '@media (max-width: 767px)': {
      display: 'none',
    },
  },
});

interface Props {
  setActiveStep: (_: number) => void;
  onCancel: () => void;
}

function PackageStep({ setActiveStep, onCancel }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();

  const {
    shooting,
    packages,
    isEditMode,
    updateShootingFields,
    saveShooting,
    validatePackageStep,
    shouldChooseTimeslot,
    serviceOffers,
    listing,
    recommendedServiceOffers,
    isSeasonalSOSelected,
    setIsSeasonalSOSelected,
    selectedPhotoCountOption,
    setSelectedPhotoCountOption,
    selectedDronePhotoCountOption,
    setSelectedDronePhotoCountOption,
    defaultPackagesPhotoCountOptions,
    defaultPackagesDronePhotoCountOptions,
    allSeasonalPhotoCountOptions,
    allSeasonalDronePhotoCountOptions,
    allDronePhotoCountOptions,
    photoCountOptions,
    setPhotoCountOptions,
    dronePhotoCountOptions,
    selectedPackageType,
    setDronePhotoCountOptions,
    setSelectedPackageType,
  } = useContext(ShootingContext);
  const isDraftMode = shooting.state === Shooting.STATE_ENUM.draft;
  const isEn = language === ENG;

  const { service_offers, shooting_params, shootingPackage } = shooting;
  const signatureServiceOffers = serviceOffers.filter((m: ServiceOffer) => {
    return m.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
  });
  const seasonalServiceOffers = serviceOffers.filter((m: ServiceOffer) => {
    return (
      m.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL ||
      m.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE
    );
  });

  let droneServiceOffers = serviceOffers.filter((m: ServiceOffer) => {
    return m.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE;
  });
  droneServiceOffers = droneServiceOffers.sort((a, b) => {
    return (
      a.serviceOffer.items[0]?.service_offer_item.hdr_photo_count -
      b.serviceOffer.items[0]?.service_offer_item.hdr_photo_count
    );
  });

  const defaultSmallestHDRPackage = packages.find((p) => {
    return p.hdr_photo_count === defaultPackagesPhotoCountOptions[1] && p.drone_photo_count === 0;
  });
  let defaultSmallestComboPackages = packages.filter((p) => {
    return p.drone_photo_count === defaultPackagesDronePhotoCountOptions[1];
  });
  defaultSmallestComboPackages = defaultSmallestComboPackages.sort((a, b) => {
    return a.hdr_photo_count - b.hdr_photo_count;
  });
  const defaultSmallestComboPackage = defaultSmallestComboPackages[0] || null;
  const defaultSmallestDroneSeasonalPackage = droneServiceOffers[0] || null;
  let defaultSmallestSeasonalServiceOffers = seasonalServiceOffers.filter((so: ServiceOffer) => {
    return (
      so.serviceOffer?.items?.length === 1 &&
      so.serviceOffer.items[0]?.service_offer_item.icon_name ===
        SERVICE_OFFER_CATEGORY_ICON.SEASONAL
    );
  });
  defaultSmallestSeasonalServiceOffers = defaultSmallestSeasonalServiceOffers.sort((a, b) => {
    return (
      a.serviceOffer.items[0]?.service_offer_item.hdr_photo_count -
      b.serviceOffer.items[0]?.service_offer_item.hdr_photo_count
    );
  });
  const defaultSmallestSeasonalServiceOffer = defaultSmallestSeasonalServiceOffers[0] || null;
  const defaultSmallestSeasonalComboServiceOffers = seasonalServiceOffers.filter(
    (so: ServiceOffer) => {
      return so.serviceOffer?.items?.length === 2;
    },
  );
  defaultSmallestSeasonalComboServiceOffers.sort((a, b) => {
    return (
      a.serviceOffer?.items[0]?.service_offer_item.hdr_photo_count -
      b.serviceOffer?.items[0]?.service_offer_item.hdr_photo_count
    );
  });
  const defaultSmallestSeasonalComboServiceOffer =
    defaultSmallestSeasonalComboServiceOffers[0] || null;

  const [loading, setLoading] = useState(false);
  const [isMinusDisabled, setIsMinusDisabled] = useState(true);
  const [isPlusDisabled, setIsPlusDisabled] = useState(false);
  const isEnglish = language === ENG;

  const fmtPhotoPackagesTitle = intl.formatMessage({
    id: 'shooting.create.titles.photoPackages',
  });
  const fmtSignaturePackageTitle = intl.formatMessage({
    id: 'shooting.create.titles.signaturePackage',
  });
  const fmtSaveDraft = intl.formatMessage({ id: 'shooting.create.buttons.saveDraft' });
  const fmtSave = intl.formatMessage({ id: 'shooting.create.buttons.save' });
  const fmtPhotoCount = intl.formatMessage({ id: 'shooting.create.labels.photoCount' });
  const fmtDronePhotoCount = intl.formatMessage({ id: 'shooting.create.labels.dronePhotoCount' });
  const fmtEnhance = intl.formatMessage({ id: 'shooting.create.labels.enhance' });
  const fmtNoPackageSelected = intl.formatMessage({
    id: 'shooting.create.labels.noPackageSelected',
  });
  const fmtPhotoType = intl.formatMessage({ id: 'shooting.create.labels.photoType' });
  const fmtInside = intl.formatMessage({ id: 'shooting.create.labels.inside' });
  const fmtOutside = intl.formatMessage({ id: 'shooting.create.labels.outside' });

  const removePhotoPackage = () => {
    const updatedPackage = null;
    const shootingParams = _.assign(shooting_params, {
      shooting_package: updatedPackage,
    });
    updateShootingFields({ shooting_params: shootingParams }, true);
    setSelectedDronePhotoCountOption(allDronePhotoCountOptions[0]);
    setSelectedPhotoCountOption(defaultPackagesPhotoCountOptions[0]);
    setPhotoCountOptions(defaultPackagesPhotoCountOptions);
    setIsSeasonalSOSelected(false);
  };
  const onToggleSignatureServiceOffer = (
    so: ServiceOffer,
    isDisabled: boolean,
    catogory: string,
  ) => {
    if (isDisabled) return;
    removePhotoPackage();
    let serviceOffers = _.clone(service_offers);
    serviceOffers = serviceOffers.filter((so: ServiceOffer) => {
      return (
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.DRONE &&
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SEASONAL
      );
    });
    const index = _.findIndex(serviceOffers, (m: ServiceOffer) => {
      return so.serviceOffer.id === m.serviceOffer.id;
    });
    if (index === -1) {
      if (catogory && catogory === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE) {
        serviceOffers = serviceOffers.filter((so: ServiceOffer) => {
          return so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
        });
        serviceOffers.push(so);
      } else {
        serviceOffers.push(so);
      }
      setSelectedPackageType(SERVICE_OFFER_CATEGORY_ICON.SIGNATURE);
    } else {
      serviceOffers.splice(index, 1);
    }
    updateShootingFields({ service_offers: serviceOffers }, true);
  };

  const removeSignatureServiceOffer = () => {
    let serviceOffers = _.clone(service_offers);
    serviceOffers = serviceOffers.filter((so: ServiceOffer) => {
      return so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
    });
    const foundSignatureServiceOffer = service_offers.find((so) => {
      return so?.serviceOffer?.category?.icon_name === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
    });
    if (foundSignatureServiceOffer) {
      serviceOffers = serviceOffers.filter((so) => {
        return (
          !so.is_child &&
          so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
        );
      });
    }
    updateShootingFields({ service_offers: serviceOffers }, true);
  };

  const onToggleServiceOffer = (so: ServiceOffer, isDisabled: boolean) => {
    return () => {
      if (isDisabled) return;
      const _serviceOffers = _.clone(shooting.service_offers);
      const index = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
        return so?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      const floorplanSelected = _serviceOffers.find((m: ServiceOffer) => {
        return m?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
      });
      const carteMeasureService = serviceOffers.find((m: ServiceOffer) => {
        return m?.serviceOffer?.id === CARTE_SERVICE_OFFERS.MEASURE;
      });
      if (index !== -1) {
        if (!(so.serviceOffer.id === CARTE_SERVICE_OFFERS.MEASURE && floorplanSelected)) {
          _serviceOffers.splice(index, 1);
        }
        const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
          return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
        });
        if (
          so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
          existingCarteMeasureIndex !== -1
        ) {
          _serviceOffers.splice(existingCarteMeasureIndex, 1);
        }
      } else {
        _serviceOffers.push(so);
        const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
          return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
        });
        if (
          so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
          carteMeasureService &&
          existingCarteMeasureIndex === -1
        ) {
          _serviceOffers.push(carteMeasureService);
        }
      }
      updateShootingFields({ service_offers: _serviceOffers }, true);
    };
  };
  const updatePackage = (_package: IPackage) => {
    if (selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE) {
      return;
    }
    let updatedPackage = null;
    updatedPackage = _package;
    const shootingParams = _.assign(shooting_params, {
      shooting_package: updatedPackage,
    });
    updateShootingFields({ shooting_params: shootingParams }, true);
    if (
      selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SHOOTING_PACKAGE &&
      (selectedPhotoCountOption || selectedDronePhotoCountOption)
    ) {
      removeSignatureServiceOffer();
    }
  };

  const removeShootingPackage = () => {
    const updatedPackage = null;
    const shootingParams = _.assign(shooting_params, {
      shooting_package: updatedPackage,
    });
    updateShootingFields({ shooting_params: shootingParams }, true);
  };
  const removeSeasonalServiceOffer = () => {
    let _service_offers = _.clone(service_offers);
    _service_offers = _service_offers.filter((so: ServiceOffer) => {
      return (
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.DRONE
      );
    });
    updateShootingFields({ service_offers: _service_offers }, true);
  };
  useEffect(() => {
    if (!packages.length) {
      return;
    }
    const foundSelectedSignatureServiceOffer = service_offers.find((m: ServiceOffer) => {
      return m.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
    });
    if (foundSelectedSignatureServiceOffer) {
      setSelectedPackageType(SERVICE_OFFER_CATEGORY_ICON.SIGNATURE);
      const target = document.getElementById(
        `service-${foundSelectedSignatureServiceOffer?.serviceOffer?.id}`,
      );
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    const mergedPhotoCountOptions = _.union(
      allSeasonalPhotoCountOptions,
      defaultPackagesPhotoCountOptions,
    );
    setPhotoCountOptions(mergedPhotoCountOptions);
    const foundSelectedSeasonalServiceOffer = service_offers.find((so: ServiceOffer) => {
      return so.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL;
    });
    if (
      foundSelectedSeasonalServiceOffer &&
      !shootingPackage?.id &&
      !foundSelectedSignatureServiceOffer
    ) {
      setSelectedPackageType(SERVICE_OFFER_CATEGORY_ICON.SHOOTING_PACKAGE);
      setIsSeasonalSOSelected(true);
      const foundItem = foundSelectedSeasonalServiceOffer?.serviceOffer?.items?.find((item) => {
        return item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL;
      });
      if (foundItem) {
        setSelectedPhotoCountOption(foundItem?.service_offer_item?.hdr_photo_count);
      }
      const found_drone_item = foundSelectedSeasonalServiceOffer.serviceOffer?.items?.find(
        (item) => {
          return item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE;
        },
      );
      if (found_drone_item) {
        const drone_count = found_drone_item?.service_offer_item?.hdr_photo_count;
        setSelectedDronePhotoCountOption(drone_count);
      }
    }
    const foundSelectedDroneServiceOffer = service_offers.find((so: ServiceOffer) => {
      return so.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE;
    });
    if (
      foundSelectedDroneServiceOffer &&
      !shootingPackage?.id &&
      !foundSelectedSignatureServiceOffer
    ) {
      setSelectedPackageType(SERVICE_OFFER_CATEGORY_ICON.SHOOTING_PACKAGE);
      setIsSeasonalSOSelected(true);
      setSelectedPhotoCountOption(0);
      if (foundSelectedDroneServiceOffer?.serviceOffer?.items) {
        setSelectedDronePhotoCountOption(
          foundSelectedDroneServiceOffer?.serviceOffer?.items[0]?.service_offer_item
            .hdr_photo_count,
        );
      } else {
        setSelectedDronePhotoCountOption(0);
      }
    }
  }, []);

  const updateServiceOffer = (isSeasonal: boolean, updatedServiceOffers) => {
    const selectedServiceOffers = updatedServiceOffers || service_offers;
    const foundSignatureServiceOffer = selectedServiceOffers.find((so) => {
      return so?.serviceOffer?.category?.icon_name === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
    });
    if (
      selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE ||
      foundSignatureServiceOffer
    ) {
      return;
    }
    let _service_offers = selectedServiceOffers;
    _service_offers = _service_offers.filter((so: ServiceOffer) => {
      return (
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.DRONE &&
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
      );
    });
    if (foundSignatureServiceOffer) {
      _service_offers = _service_offers.filter((so) => {
        return (
          !so.is_child &&
          so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
        );
      });
    }
    if (!isSeasonal) {
      setSelectedPhotoCountOption(photoCountOptions[0]);
      setSelectedDronePhotoCountOption(dronePhotoCountOptions[0]);
      updateShootingFields({ service_offers: _service_offers }, true);
      return;
    }

    let foundSeasonalServiceOffer;
    const foundSameSeasonalHDRServiceOffers = seasonalServiceOffers.filter((so: ServiceOffer) => {
      return so.serviceOffer?.items?.find((item) => {
        return (
          item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
          item.service_offer_item.hdr_photo_count === selectedPhotoCountOption
        );
      });
    });
    if (foundSameSeasonalHDRServiceOffers) {
      [foundSeasonalServiceOffer] = foundSameSeasonalHDRServiceOffers;
      const foundSameDroneCountSeasonalServiceOffer = foundSameSeasonalHDRServiceOffers.find(
        (so: ServiceOffer) => {
          return so.serviceOffer?.items?.find((item) => {
            return (
              item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE &&
              item.service_offer_item.hdr_photo_count === selectedDronePhotoCountOption
            );
          });
        },
      );
      if (foundSameDroneCountSeasonalServiceOffer) {
        foundSeasonalServiceOffer = foundSameDroneCountSeasonalServiceOffer;
      } else {
        const foundOnlyHDRSeasonalServiceOffer = foundSameSeasonalHDRServiceOffers.find((so) => {
          return (
            so.serviceOffer?.items?.length === 1 &&
            so.serviceOffer?.items[0]?.service_offer_item.icon_name ===
              SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
            so.serviceOffer?.items[0]?.service_offer_item.hdr_photo_count ===
              selectedPhotoCountOption
          );
        });
        if (foundOnlyHDRSeasonalServiceOffer) {
          foundSeasonalServiceOffer = foundOnlyHDRSeasonalServiceOffer;
        }
      }
    }
    let foundSeasonalDroneCounts = [];
    let samePhotoCountSeasonalServiceOffers = [];
    if (selectedPhotoCountOption === 0) {
      samePhotoCountSeasonalServiceOffers = seasonalServiceOffers.filter((so: ServiceOffer) => {
        return so.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE;
      });
      if (samePhotoCountSeasonalServiceOffers.length > 0) {
        const foundDroneOnlyServiceOffer = samePhotoCountSeasonalServiceOffers.find((so) => {
          return (
            so.serviceOffer?.items[0]?.service_offer_item.hdr_photo_count ===
            selectedDronePhotoCountOption
          );
        });
        if (foundDroneOnlyServiceOffer) {
          foundSeasonalServiceOffer = foundDroneOnlyServiceOffer;
        }
      }
    } else {
      samePhotoCountSeasonalServiceOffers = seasonalServiceOffers.filter((so: ServiceOffer) => {
        return so.serviceOffer?.items?.find((item) => {
          return (
            item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
            item.service_offer_item.hdr_photo_count === selectedPhotoCountOption
          );
        });
      });
    }
    if (samePhotoCountSeasonalServiceOffers.length > 0) {
      samePhotoCountSeasonalServiceOffers.forEach((so: ServiceOffer) => {
        so.serviceOffer?.items?.forEach((item) => {
          if (
            item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE &&
            !foundSeasonalDroneCounts.includes(item.service_offer_item.hdr_photo_count)
          ) {
            foundSeasonalDroneCounts.push(item.service_offer_item.hdr_photo_count);
          } else if (!foundSeasonalDroneCounts.includes(0)) {
            foundSeasonalDroneCounts.push(0);
          }
        });
      });
    }
    foundSeasonalDroneCounts = foundSeasonalDroneCounts.sort((a, b) => {
      return a - b;
    });
    if (isSeasonalSOSelected) {
      if (selectedPhotoCountOption === 0) {
        setDronePhotoCountOptions(allDronePhotoCountOptions);
      } else {
        setDronePhotoCountOptions(foundSeasonalDroneCounts);
      }
    } else {
      setDronePhotoCountOptions(defaultPackagesDronePhotoCountOptions);
    }
    if (!foundSeasonalDroneCounts.includes(selectedDronePhotoCountOption) && isSeasonalSOSelected) {
      if (selectedPhotoCountOption > 0) {
        setSelectedDronePhotoCountOption(
          foundSeasonalDroneCounts[foundSeasonalDroneCounts.length - 1],
        );
      } else {
        removeSeasonalServiceOffer();
      }
    }
    if (foundSeasonalServiceOffer) {
      _service_offers.push(foundSeasonalServiceOffer);
    }
    updateShootingFields({ service_offers: _service_offers }, true);
  };
  const removeSignatureAndSeasonalServiceOffer = () => {
    let _service_offers = _.clone(service_offers);
    _service_offers = _service_offers.filter((so: ServiceOffer) => {
      return (
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE &&
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
        so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.DRONE
      );
    });
    const foundSignatureServiceOffer = service_offers.find((so) => {
      return so?.serviceOffer?.category?.icon_name === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
    });
    if (foundSignatureServiceOffer) {
      _service_offers = _service_offers.filter((so) => {
        return (
          !so.is_child &&
          so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
        );
      });
    }
    updateShootingFields({ service_offers: _service_offers }, true);
  };
  useEffect(() => {
    const foundPackage = packages.find((p) => {
      return (
        p.hdr_photo_count === selectedPhotoCountOption + selectedDronePhotoCountOption &&
        p.drone_photo_count === selectedDronePhotoCountOption
      );
    });
    const foundOnlyPhotoPackage = packages.find((p) => {
      return (
        p.hdr_photo_count - p.drone_photo_count === selectedPhotoCountOption &&
        p.drone_photo_count === 0
      );
    });
    const result = seasonalServiceOffers.find((so) => {
      const hasDrone = so.serviceOffer?.items?.some((item) => {
        return (
          item.service_offer_item.icon_name === 'drone' &&
          item.service_offer_item.hdr_photo_count === selectedDronePhotoCountOption
        );
      });
      const hasSeasonal = so.serviceOffer?.items?.some((item) => {
        return (
          item.service_offer_item.icon_name === 'seasonal' &&
          item.service_offer_item.hdr_photo_count === selectedPhotoCountOption
        );
      });
      if (selectedDronePhotoCountOption === 0) {
        return so.serviceOffer?.items?.length === 1 && hasSeasonal;
      }
      return hasDrone && hasSeasonal;
    });
    if (foundPackage && !result) {
      updatePackage(foundPackage);
      removeSignatureAndSeasonalServiceOffer();
      if (
        isSeasonalSOSelected &&
        (selectedPhotoCountOption === 0 ||
          !allSeasonalPhotoCountOptions.includes(selectedPhotoCountOption))
      ) {
        setIsSeasonalSOSelected(false);
      }
    } else if (foundOnlyPhotoPackage && !result) {
      updatePackage(null);
      removeSignatureAndSeasonalServiceOffer();
      if (isSeasonalSOSelected && selectedPhotoCountOption === 0) {
        setIsSeasonalSOSelected(false);
      }
      let foundSamePhotoCountPackages = packages.filter((p) => {
        return selectedPhotoCountOption === p.hdr_photo_count - p.drone_photo_count;
      });
      foundSamePhotoCountPackages = foundSamePhotoCountPackages.sort((a, b) => {
        return a.drone_photo_count - b.drone_photo_count;
      });
      let foundSamePhotoCountPackageDronePhotoCounts = foundSamePhotoCountPackages.map((p) => {
        return p.drone_photo_count;
      });
      if (!foundSamePhotoCountPackageDronePhotoCounts.length) {
        foundSamePhotoCountPackageDronePhotoCounts = [0];
      }
      if (!foundSamePhotoCountPackageDronePhotoCounts.includes(selectedDronePhotoCountOption)) {
        setSelectedDronePhotoCountOption(
          foundSamePhotoCountPackageDronePhotoCounts[
            foundSamePhotoCountPackageDronePhotoCounts.length - 1
          ],
        );
      }
    } else if (foundPackage && !isSeasonalSOSelected) {
      updatePackage(foundPackage);
      removeSignatureAndSeasonalServiceOffer();
    } else {
      if (selectedPhotoCountOption === 0 && selectedDronePhotoCountOption > 0) {
        setIsSeasonalSOSelected(true);
      }
      let updatedServiceOffers = _.clone(service_offers);
      const foundSignatureServiceOffer = service_offers.find((so: ServiceOffer) => {
        return so.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
      });
      if (
        foundSignatureServiceOffer &&
        (selectedPhotoCountOption || selectedDronePhotoCountOption)
      ) {
        removeSignatureServiceOffer();
        updatedServiceOffers = updatedServiceOffers.filter((so: ServiceOffer) => {
          return so.serviceOffer.category.icon_name !== SERVICE_OFFER_CATEGORY_ICON.SIGNATURE;
        });
      }
      updatePackage(null);
      removeSeasonalServiceOffer();
      updateServiceOffer(true, updatedServiceOffers);
    }
    setIsMinusDisabled(
      selectedPhotoCountOption === photoCountOptions[0] || !photoCountOptions.length,
    );
    const maxPhotoCountOptions = isSeasonalSOSelected
      ? allSeasonalDronePhotoCountOptions
      : defaultPackagesPhotoCountOptions;
    setIsPlusDisabled(
      selectedPhotoCountOption === maxPhotoCountOptions[maxPhotoCountOptions.length - 1],
    );
  }, [selectedPhotoCountOption, selectedDronePhotoCountOption]);

  useEffect(() => {
    if (isSeasonalSOSelected) {
      const mergedPhotoCountOptions = _.union(
        allSeasonalPhotoCountOptions,
        defaultPackagesPhotoCountOptions,
      );
      setPhotoCountOptions(mergedPhotoCountOptions);
    } else {
      setPhotoCountOptions(defaultPackagesPhotoCountOptions);
    }
    const maxPhotoCountOptions = isSeasonalSOSelected
      ? allSeasonalDronePhotoCountOptions
      : defaultPackagesPhotoCountOptions;
    setIsPlusDisabled(
      selectedPhotoCountOption === maxPhotoCountOptions[maxPhotoCountOptions.length - 1],
    );
  }, [isSeasonalSOSelected]);
  useEffect(() => {
    if (isSeasonalSOSelected) {
      return;
    }
    let foundSamePhotoCountPackages = packages.filter((p) => {
      return selectedPhotoCountOption === p.hdr_photo_count - p.drone_photo_count;
    });
    foundSamePhotoCountPackages = foundSamePhotoCountPackages.sort((a, b) => {
      return a.drone_photo_count - b.drone_photo_count;
    });
    let foundSamePhotoCountPackageDronePhotoCounts = foundSamePhotoCountPackages.map((p) => {
      return p.drone_photo_count;
    });
    if (!foundSamePhotoCountPackageDronePhotoCounts.length) {
      foundSamePhotoCountPackageDronePhotoCounts = [0];
    }
    if (selectedPhotoCountOption !== 0) {
      setDronePhotoCountOptions(foundSamePhotoCountPackageDronePhotoCounts);
    }
  }, [selectedPhotoCountOption, isSeasonalSOSelected]);

  const getPackageItemIcon = (item) => {
    switch (item) {
      case 'hdr':
        return images.shooting;
      case 'virtual_tour':
        return images.virtualTour;
      case '360_video':
        return images.video360;
      case 'basic_staging':
        return images.staging;
      case 'floor_types':
        return images.floorplan;
      case 'seasonal':
        return images.seasonal;
      case 'room_measurements':
        return images.measurements;
      default:
        return null;
    }
  };

  const onPreviousStep = () => {
    setActiveStep(SHOOTING_STEPS.PROPERTY);
  };

  const onUpdate = () => {
    if (!validatePackageStep()) return;

    if (shooting.state !== Shooting.STATE_ENUM.draft && shouldChooseTimeslot()) {
      setActiveStep(SHOOTING_STEPS.SELECT_DATETIME);
    } else {
      saveShooting();
    }
  };

  const onNextStep = () => {
    setActiveStep(SHOOTING_STEPS.SERVICE);
  };

  const handleChangePackageType = (type: string) => {
    setSelectedPackageType(type);
  };

  const onAddPhotoCount = () => {
    const options = photoCountOptions;
    const index = options.indexOf(selectedPhotoCountOption);
    if (index === options.length - 1) return;
    setSelectedPhotoCountOption(options[index + 1]);
  };

  const onRemovePhotoCount = () => {
    if (isMinusDisabled) return;
    const options = photoCountOptions;
    const index = options.indexOf(selectedPhotoCountOption);
    if (index === 0) return;
    setSelectedPhotoCountOption(options[index - 1]);
  };

  const onChangeSeasonalOption = (isSeasonal: boolean) => {
    removeSignatureAndSeasonalServiceOffer();
    setIsSeasonalSOSelected(isSeasonal);
    const foundPackage = packages.find((p) => {
      return (
        p.hdr_photo_count === selectedPhotoCountOption + selectedDronePhotoCountOption &&
        p.drone_photo_count === selectedDronePhotoCountOption
      );
    });
    let foundSamePhotoCountPackages = packages.filter((p) => {
      return p.hdr_photo_count - p.drone_photo_count === selectedPhotoCountOption;
    });
    foundSamePhotoCountPackages = foundSamePhotoCountPackages.sort((a, b) => {
      return a.drone_photo_count - b.drone_photo_count;
    });
    const foundClosestSamePhotoCountPackage =
      foundSamePhotoCountPackages[foundSamePhotoCountPackages.length - 1];
    const foundOnlyPhotoPackage = packages.find((p) => {
      return (
        p.hdr_photo_count - p.drone_photo_count === selectedPhotoCountOption &&
        p.drone_photo_count === 0
      );
    });
    const result = seasonalServiceOffers.find((so) => {
      const hasDrone = so.serviceOffer?.items?.some((item) => {
        return (
          item.service_offer_item.icon_name === 'drone' &&
          item.service_offer_item.hdr_photo_count === selectedDronePhotoCountOption
        );
      });
      const hasSeasonal = so.serviceOffer?.items?.some((item) => {
        return (
          item.service_offer_item.icon_name === 'seasonal' &&
          item.service_offer_item.hdr_photo_count === selectedPhotoCountOption
        );
      });
      if (selectedDronePhotoCountOption === 0) {
        return so.serviceOffer?.items?.length === 1 && hasSeasonal;
      }
      return hasDrone && hasSeasonal;
    });
    if (isSeasonal) {
      if (result) {
        updatePackage(null);
        updateServiceOffer(true, service_offers);
      } else {
        const foundSameDroneCountSeasonalServiceOffers = seasonalServiceOffers.filter(
          (so: ServiceOffer) => {
            return so.serviceOffer?.items?.find((item) => {
              return (
                item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE &&
                item.service_offer_item.hdr_photo_count === selectedDronePhotoCountOption
              );
            });
          },
        );
        let photo_count = 0;
        if (foundSameDroneCountSeasonalServiceOffers.length) {
          let hdr_photo_counts = [];
          foundSameDroneCountSeasonalServiceOffers.forEach((so: ServiceOffer) => {
            so?.serviceOffer?.items?.forEach((item) => {
              if (
                item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL &&
                !hdr_photo_counts.includes(item.service_offer_item.hdr_photo_count)
              ) {
                hdr_photo_counts.push(item.service_offer_item.hdr_photo_count);
              }
            });
          });
          hdr_photo_counts = hdr_photo_counts.sort((a, b) => {
            return a - b;
          });
          photo_count = hdr_photo_counts[hdr_photo_counts.length - 1];
        } else {
          const foundOnlyHDRSeasonalServiceOffers = seasonalServiceOffers.filter((so) => {
            return (
              so.serviceOffer?.items?.length === 1 &&
              so.serviceOffer?.items[0]?.service_offer_item.icon_name ===
                SERVICE_OFFER_CATEGORY_ICON.SEASONAL
            );
          });
          let hdrOnlyPhotoCounts = foundOnlyHDRSeasonalServiceOffers.map((so) => {
            return so.serviceOffer?.items[0]?.service_offer_item.hdr_photo_count;
          });
          hdrOnlyPhotoCounts = hdrOnlyPhotoCounts.sort((a, b) => {
            return a - b;
          });
          if (selectedPhotoCountOption > 0) {
            photo_count = hdrOnlyPhotoCounts[hdrOnlyPhotoCounts.length - 1];
          }
          setSelectedDronePhotoCountOption(0);
        }
        setSelectedPhotoCountOption(photo_count);
        updatePackage(null);
      }
    } else if (!foundPackage && foundClosestSamePhotoCountPackage) {
      updatePackage(foundClosestSamePhotoCountPackage);
    } else if (foundPackage) {
      updatePackage(foundPackage);
    } else if (foundOnlyPhotoPackage) {
      setSelectedDronePhotoCountOption(0);
      updatePackage(null);
    } else {
      const foundSameDronePackages = packages.filter((p) => {
        return p.drone_photo_count === selectedDronePhotoCountOption;
      });
      if (foundSameDronePackages.length) {
        let hdrCounts = foundSameDronePackages.map((p) => {
          return p.hdr_photo_count - p.drone_photo_count;
        });
        hdrCounts = hdrCounts.sort((a, b) => {
          return a - b;
        });
        const closestHDRCount = _.find(_.sortBy(hdrCounts), (count) => {
          return count >= selectedPhotoCountOption;
        });
        if (selectedPhotoCountOption > 0) {
          setSelectedPhotoCountOption(closestHDRCount);
        } else {
          setSelectedDronePhotoCountOption(0);
        }
      }
    }
  };

  const onChangeDronePhotoCount = (count: number) => {
    if (dronePhotoCountOptions.includes(count)) {
      setSelectedDronePhotoCountOption(count);
    }
  };

  const getCountColor = (count: number) => {
    if (selectedDronePhotoCountOption === count) {
      return COLOR.WHITE;
    }
    if (dronePhotoCountOptions.includes(count)) {
      return COLOR.BLACK;
    }
    return COLOR.GREY;
  };

  const isServiceSelected = (so: ServiceOffer) => {
    return !!shooting.service_offers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
  };

  const checkIfChild = (so: ServiceOffer) => {
    const foundService = service_offers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
    if (foundService) {
      return foundService.is_child;
    }
    return false;
  };

  const isServiceDisabled = (so: ServiceOffer) => {
    if (so.serviceOffer?.is_global) {
      return false;
    }

    const nonGlobalServiceOffers = service_offers?.filter((m: ServiceOffer) => {
      return !m.serviceOffer.is_global;
    });

    const ngso = nonGlobalServiceOffers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
    if (ngso) return false;

    const userIds = _.flatten(
      nonGlobalServiceOffers.map((so: ServiceOffer) => {
        return so.serviceOffer.users;
      }),
    );

    const serviceOfferTechs = _.get(so.serviceOffer, 'users', []);

    for (let i = 0; i < serviceOfferTechs.length; i++) {
      const user = serviceOfferTechs[i];
      if (userIds.indexOf(user) !== -1) return false;
    }

    return !!_.intersection(userIds, so.serviceOffer?.users || []).length;
  };

  const getOriginalPackagePrice = () => {
    const defaultPackage =
      shootingPackage?.drone_photo_count === 0
        ? defaultSmallestHDRPackage
        : defaultSmallestComboPackage;
    let pricePerPhoto = Number(defaultPackage.price) / defaultPackage.hdr_photo_count;
    pricePerPhoto = Math.round(pricePerPhoto * 100) / 100;
    return pricePerPhoto;
  };

  const getAllChildrenServiceOffersPrice = (so: ServiceOffer) => {
    let price = 0;
    so?.serviceOffer?.children?.forEach((item) => {
      price += item.service_offer.price;
    });
    price = Math.round(price * 100) / 100;
    return price;
  };

  const renderSignatureServiceOffers = () => {
    return (
      <Box className={styles.serviceContent}>
        <Box className={styles.categoryTitleContent}>
          <img src={images.signature} alt='signature' className={styles.categoryIcon} />
          <Typography className={styles.selectedServiceTitle}>
            {fmtSignaturePackageTitle}
          </Typography>
        </Box>
        {signatureServiceOffers.map((service, index) => {
          const isSelected = isServiceSelected(service);
          const isDisabled = isServiceDisabled(service);
          const originalPrice = getAllChildrenServiceOffersPrice(service);
          let savingPercent = 0;
          if (originalPrice > 0) {
            savingPercent = Math.round(
              ((originalPrice - service.serviceOffer.price) / originalPrice) * 100,
            );
          }
          let { items } = service.serviceOffer;
          items = items.sort((a, b) => {
            return a.service_offer_item.order_index - b.service_offer_item.order_index;
          });
          const examples = [];
          items.forEach((item) => {
            if (item.service_offer_item.example) {
              examples.push(item.service_offer_item.example);
            }
          });
          const isSaved = savingPercent > 0;
          return (
            <Grid
              container
              className={isSelected ? styles.selectedBlock : styles.block}
              spacing={2}
              key={index}
              id={`service-${service.serviceOffer.id}`}
            >
              <Grid item md={examples.length ? 5 : 11}>
                <div className={styles.selectedServiceContent}>
                  <Box className={styles.serviceTitleRow}>
                    <Typography className={styles.title}>
                      {isEnglish
                        ? service.serviceOffer.display_name
                        : service.serviceOffer.display_name_fr}
                    </Typography>
                  </Box>
                  <Box className={styles.servicePriceRow}>
                    <Box className={styles.priceRow}>
                      <div className={styles.row}>
                        <Typography className={styles.priceText}>
                          {`$ ${service.serviceOffer.price}`}
                        </Typography>
                        {isSaved && (
                          <Box className={styles.signatureSavingContent}>
                            <Typography className={styles.bold}>{`-${savingPercent}%`}</Typography>
                          </Box>
                        )}
                      </div>
                      {isSaved && (
                        <Typography className={styles.originalPrice}>
                          {`$ ${originalPrice}`}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  {service.serviceOffer.require_mls === true && listing.mls !== '' && (
                    <Box>
                      <Typography style={{ color: COLOR.BLUE }}>{listing.mls}</Typography>
                    </Box>
                  )}
                  {items.map((item, index) => {
                    return (
                      <Box key={index} className={styles.packageDescriptionRow}>
                        <img
                          style={{ width: 40, height: 40, marginRight: 10 }}
                          src={getServiceDescriptionIcon(item.service_offer_item.icon_name)}
                          alt='description icon'
                        />
                        <Typography className={styles.packageDescription}>
                          {isEnglish
                            ? item.service_offer_item.description
                            : item.service_offer_item.description_fr}
                        </Typography>
                      </Box>
                    );
                  })}
                  {isDisabled && (
                    <Typography style={{ color: COLOR.GREY }}>
                      {intl.formatMessage({
                        id: 'shooting.create.labels.serviceOfferDisabledHelp',
                      })}
                    </Typography>
                  )}
                </div>
              </Grid>
              {examples.length > 0 && (
                <Grid item md={examples.length ? 6 : null} sm={examples.length ? 12 : null}>
                  <div className={styles.examples}>
                    <Grid spacing={1} container>
                      {items.map((item, index) => {
                        const { example } = item.service_offer_item;
                        if (!example || !example.image_url) {
                          return null;
                        }
                        return (
                          <Grid item md={6} sm={6} xs={12} key={index}>
                            <img
                              className={styles.exampleImage}
                              src={example?.image_url}
                              alt='example'
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </div>
                </Grid>
              )}
              <Grid
                item
                md={1}
                className={styles.tick}
                onClick={() => {
                  return onToggleSignatureServiceOffer(
                    service,
                    isDisabled,
                    SERVICE_OFFER_CATEGORY_ICON.SIGNATURE,
                  );
                }}
              >
                {isSelected ? (
                  <img src={images.tick} style={{ width: 30, height: 30 }} alt='checkbox' />
                ) : (
                  <Box className={styles.serviceDivider} />
                )}
              </Grid>
            </Grid>
          );
        })}
      </Box>
    );
  };
  const renderSeasonalOptions = () => {
    return (
      <div className={styles.photoCountRow}>
        <div className={styles.row}>
          <img src={images.seasonal} alt='seasonal' className={styles.bigIcon} />
          <Typography className={styles.countText}>{fmtPhotoType}</Typography>
        </div>
        <div className={styles.seasonalOptionRow}>
          <div
            className={!isSeasonalSOSelected ? styles.selectedSeasonal : styles.seasonal}
            onClick={() => {
              return onChangeSeasonalOption(false);
            }}
          >
            <img
              className={styles.seasonalIcon}
              src={isSeasonalSOSelected ? images.inside : images.inside_white}
              alt='inside'
            />
            <Typography className={styles.seasonalText}>{fmtInside}</Typography>
          </div>
          <div
            className={isSeasonalSOSelected ? styles.selectedSeasonal : styles.seasonal}
            onClick={() => {
              return onChangeSeasonalOption(true);
            }}
          >
            <img
              className={styles.seasonalIcon}
              src={isSeasonalSOSelected ? images.facade_white : images.facade}
              alt='inside'
            />
            <Typography className={styles.seasonalText}>{fmtOutside}</Typography>
          </div>
        </div>
      </div>
    );
  };

  const renderPhotoCount = () => {
    return (
      <div>
        <div className={styles.photoCountRow}>
          <div className={styles.row}>
            <img className={styles.bigIcon} src={images.camera_blue} alt='camera' />
            <Typography className={styles.countText}>{fmtPhotoCount}</Typography>
          </div>
          <div className={styles.row}>
            <IconButton
              disabled={isMinusDisabled}
              className={styles.minusIconButton}
              onClick={onRemovePhotoCount}
            >
              <RemoveCircleOutlineRoundedIcon
                className={isMinusDisabled ? styles.disabledIcon : styles.minusIcon}
              />
            </IconButton>
            <Typography className={styles.photoCount}>{selectedPhotoCountOption}</Typography>
            <IconButton
              disabled={isPlusDisabled}
              className={styles.plusIconButton}
              onClick={onAddPhotoCount}
            >
              <AddCircleOutlineRoundedIcon
                className={isPlusDisabled ? styles.disabledIcon : styles.plusIcon}
              />
            </IconButton>
          </div>
        </div>
        <div className={styles.photoCountRow}>
          <div className={styles.row}>
            <img className={styles.bigIcon} src={images.drone} alt='drone' />
            <Typography className={styles.countText}>{fmtDronePhotoCount}</Typography>
          </div>
          <div className={styles.droneRow}>
            <div className={styles.line} />
            {allDronePhotoCountOptions.map((count, index) => {
              return (
                <div
                  key={index}
                  className={
                    selectedDronePhotoCountOption === count ? styles.selectedCircle : styles.circle
                  }
                  style={{
                    outlineColor: dronePhotoCountOptions.includes(count)
                      ? COLOR.LIGHT_BLUE
                      : COLOR.GREY,
                  }}
                  onClick={() => {
                    return onChangeDronePhotoCount(count);
                  }}
                >
                  <Typography
                    className={styles.dronePhotoCount}
                    style={{
                      color: getCountColor(count),
                    }}
                  >
                    {count}
                  </Typography>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const renderRecommendedServices = () => {
    if (recommendedServiceOffers.length === 0) {
      return null;
    }
    return (
      <div className={styles.servicesCard}>
        <Typography className={styles.bold}>{fmtEnhance}</Typography>
        <div className={styles.servicesRow}>
          {recommendedServiceOffers.map((s) => {
            const isSelected = isServiceSelected(s);
            const isDisabled = isServiceDisabled(s);
            const isChild = checkIfChild(s);
            return (
              <div
                className={styles.serviceCard}
                key={s.serviceOffer.id}
                style={{
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3)), url(${s.serviceOffer?.example?.image_url})`,
                  backgroundSize: 'cover',
                  border: isSelected && !isChild ? `3px solid ${COLOR.LIGHT_BLUE}` : 'none',
                }}
                onClick={onToggleServiceOffer(s, isDisabled)}
              >
                <div className={styles.packageDescriptionRow}>
                  <Typography>
                    {isEnglish ? s.serviceOffer.display_name : s.serviceOffer.display_name_fr}
                  </Typography>
                </div>
                <div key={s.serviceOffer.id} className={styles.servicePriceRow}>
                  <Typography className={styles.servicePrice}>
                    {`$ ${s.serviceOffer.price}`}
                  </Typography>
                  <div className={styles.tick}>
                    <div className={styles.circleIcon}>
                      {isSelected && !isChild ? (
                        <DoneRounded className={styles.plus} />
                      ) : (
                        <AddRoundedIcon className={styles.plus} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderShootingPackageItems = () => {
    let pricePerPhoto = Number(shootingPackage?.price) / shootingPackage?.hdr_photo_count;
    pricePerPhoto = Math.round(pricePerPhoto * 100) / 100;
    const isDefaultPackage = pricePerPhoto === getOriginalPackagePrice();
    let savingPercent = 0;
    if (!isDefaultPackage) {
      savingPercent = (getOriginalPackagePrice() - pricePerPhoto) / getOriginalPackagePrice();
      savingPercent = Math.round(savingPercent * 100);
    }
    return (
      <div>
        {shootingPackage && shootingPackage?.id ? (
          <Box className={styles.selectedPackage}>
            {shootingPackage.is_drone_photo ? (
              <Box className={styles.row}>
                <Typography className={styles.photoCount}>
                  {shootingPackage.hdr_photo_count - shootingPackage.drone_photo_count}
                </Typography>
                <img className={styles.cameraIcon} src={images.shooting} alt='shooting' />
                <Typography className={styles.photoCount}>
                  {shootingPackage.drone_photo_count}
                </Typography>
                <img className={styles.droneIcon} src={images.drone} alt='drone' />
              </Box>
            ) : (
              <Box className={styles.row}>
                <Typography className={styles.bold}>{shootingPackage.hdr_photo_count}</Typography>
                <img className={styles.cameraIcon} src={images.shooting} alt='shooting' />
              </Box>
            )}
            <div className={styles.priceContent}>
              <div className={styles.shootingPackageRow}>
                <Typography className={styles.shootingPriceText}>
                  {`$ ${shootingPackage.price}`}
                </Typography>
                {savingPercent > 0 && (
                  <div className={styles.savingContent}>
                    <Typography className={styles.savingText}>{`- ${savingPercent} %`}</Typography>
                  </div>
                )}
              </div>
              {!isDefaultPackage && (
                <div className={styles.row}>
                  <Typography className={styles.originalPrice}>
                    {`$ ${getOriginalPackagePrice()}`}
                  </Typography>
                  <Typography className={styles.pricePerPhoto}>
                    {`$ ${pricePerPhoto} / photo`}
                  </Typography>
                </div>
              )}
            </div>
          </Box>
        ) : (
          <Typography className={styles.none}>{fmtNoPackageSelected}</Typography>
        )}
        {shootingPackage && shootingPackage?.package_items?.length ? (
          <div>
            <div className={styles.divider} />
            <Typography className={styles.subtitle}>
              {intl.formatMessage({ id: 'shooting.create.titles.serviceOffers' })}
            </Typography>
            <Grid container>
              {shootingPackage.package_items &&
                shootingPackage.package_items
                  .sort((a, b) => {
                    return (
                      a.shooting_package_item.order_index - b.shooting_package_item.order_index
                    );
                  })
                  .map((item: IPackage, index: number) => {
                    return (
                      <Grid
                        item
                        md={6}
                        sm={12}
                        className={styles.packageDescriptionRow}
                        key={index}
                      >
                        <img
                          style={{ width: 40, height: 40, marginRight: 5 }}
                          src={getPackageItemIcon(item.shooting_package_item.icon_name)}
                          alt='shooting package'
                        />
                        <Typography>
                          {isEnglish
                            ? item.shooting_package_item.name
                            : item.shooting_package_item.name_fr}
                        </Typography>
                      </Grid>
                    );
                  })}
            </Grid>
          </div>
        ) : null}
      </div>
    );
  };

  const renderSelectedPackage = () => {
    if (isSeasonalSOSelected) return null;
    return (
      <div className={styles.card}>
        <Typography className={styles.bold}>
          {intl.formatMessage({
            id: 'shooting.create.titles.selectedPackage',
          })}
        </Typography>
        {renderShootingPackageItems()}
      </div>
    );
  };

  const renderServiceOfferItems = (so) => {
    let photoCounts = 0;
    if (so?.items) {
      so?.items?.forEach((item) => {
        photoCounts += item?.service_offer_item?.hdr_photo_count;
      });
    }
    const foundDroneItem = so?.items?.find((item) => {
      return item.service_offer_item.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE;
    });
    let defaultServiceOffer = foundDroneItem
      ? defaultSmallestSeasonalComboServiceOffer
      : defaultSmallestSeasonalServiceOffer;
    if (so.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE) {
      defaultServiceOffer = defaultSmallestDroneSeasonalPackage;
    }
    const defaultServiceOfferPhotoCounts = defaultServiceOffer.serviceOffer?.items?.reduce(
      (acc, item) => {
        return acc + item?.service_offer_item?.hdr_photo_count;
      },
      0,
    );
    let defaultServicePricePerPhoto =
      defaultServiceOffer.serviceOffer.price / defaultServiceOfferPhotoCounts;
    defaultServicePricePerPhoto = Math.round(defaultServicePricePerPhoto * 100) / 100;
    const pricePerPhoto = Math.round(so.price / photoCounts);
    const isDefaultPackage = so.price === defaultServiceOffer.serviceOffer.price;
    let savingPercent = 0;
    if (!isDefaultPackage) {
      savingPercent = (defaultServicePricePerPhoto - pricePerPhoto) / defaultServicePricePerPhoto;
      savingPercent = Math.round(savingPercent * 100);
    }

    return (
      <div>
        <div className={styles.selectedPackage}>
          <Typography className={styles.seasonalName}>
            {isEn ? so.display_name : so.display_name_fr}
          </Typography>
          <div className={styles.priceContent}>
            <div className={styles.shootingPackageRow}>
              <Typography className={styles.seasonalPriceText}>{`$ ${so.price}`}</Typography>
              {savingPercent > 0 && (
                <div className={styles.savingContent}>
                  <Typography className={styles.savingText}>{`- ${savingPercent} %`}</Typography>
                </div>
              )}
            </div>
            {!isDefaultPackage && (
              <div className={styles.row}>
                <Typography className={styles.originalPrice}>
                  {`$ ${defaultServicePricePerPhoto}`}
                </Typography>
                <Typography className={styles.pricePerPhoto}>
                  {`$ ${pricePerPhoto} / photo`}
                </Typography>
              </div>
            )}
          </div>
        </div>
        <Grid container>
          {so?.items &&
            so.items
              .sort((a, b) => {
                return a.service_offer_item.order_index - b.service_offer_item.order_index;
              })
              .map((item, index) => {
                return (
                  <Grid item md={6} sm={12} key={index} className={styles.packageDescriptionRow}>
                    <img
                      style={{ width: 40, height: 40, marginRight: 5 }}
                      src={getServiceDescriptionIcon(item.service_offer_item.icon_name)}
                      alt='description icon'
                    />
                    <Typography className={styles.packageDescription}>
                      {isEnglish
                        ? item.service_offer_item.description
                        : item.service_offer_item.description_fr}
                    </Typography>
                  </Grid>
                );
              })}
        </Grid>
      </div>
    );
  };

  const renderSelectedSeasonalService = () => {
    if (!isSeasonalSOSelected) return null;
    const foundSelectedSeasonalServiceOffer = service_offers.find((so: ServiceOffer) => {
      return (
        so.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.SEASONAL ||
        so.serviceOffer.category.icon_name === SERVICE_OFFER_CATEGORY_ICON.DRONE
      );
    });
    return (
      <div className={styles.card}>
        <Typography className={styles.bold}>
          {intl.formatMessage({
            id: 'shooting.create.titles.selectedPackage',
          })}
          {!foundSelectedSeasonalServiceOffer?.serviceOffer ? (
            <Typography className={styles.none}>{fmtNoPackageSelected}</Typography>
          ) : (
            renderServiceOfferItems(foundSelectedSeasonalServiceOffer.serviceOffer)
          )}
        </Typography>
      </div>
    );
  };

  const renderPhotoPackages = () => {
    return (
      <Box className={styles.group}>
        {renderSeasonalOptions()}
        {renderPhotoCount()}
        {renderRecommendedServices()}
        {renderSelectedPackage()}
        {renderSelectedSeasonalService()}
      </Box>
    );
  };

  const renderPackageCatogories = () => {
    return (
      <Box className={styles.categoryContent}>
        {signatureServiceOffers.length ? (
          <div className={styles.tabs}>
            <div
              className={
                selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
                  ? styles.selectedTab
                  : styles.tab
              }
              onClick={() => {
                return handleChangePackageType(SERVICE_OFFER_CATEGORY_ICON.SIGNATURE);
              }}
            >
              <img
                src={
                  selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
                    ? images.signature
                    : images.signature_white
                }
                alt='signature'
                className={styles.tabIcon}
              />
              <Typography>{fmtSignaturePackageTitle}</Typography>
            </div>
            <div
              className={
                selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SHOOTING_PACKAGE
                  ? styles.selectedTab
                  : styles.tab
              }
              onClick={() => {
                return handleChangePackageType(SERVICE_OFFER_CATEGORY_ICON.SHOOTING_PACKAGE);
              }}
            >
              <img
                src={
                  selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SHOOTING_PACKAGE
                    ? images.camera_blue
                    : images.camera_white
                }
                alt='photo_package'
                className={styles.tabIcon}
              />
              <Typography>{fmtPhotoPackagesTitle}</Typography>
            </div>
          </div>
        ) : null}
      </Box>
    );
  };
  const renderPackages = () => {
    return (
      <Box>
        {renderPackageCatogories()}
        {selectedPackageType === SERVICE_OFFER_CATEGORY_ICON.SIGNATURE
          ? renderSignatureServiceOffers()
          : renderPhotoPackages()}
      </Box>
    );
  };
  return (
    <>
      <Box className={classNames('ScrollView', styles.stepContent)}>
        {loading ? <HvPleaseWait className={styles.wait} /> : <>{renderPackages()}</>}
      </Box>

      <Box className='ButtonsBox'>
        <div className={styles.row}>
          <Button variant='contained' className='BackButton' onClick={onCancel}>
            {intl.formatMessage({ id: 'shooting.create.buttons.cancel' })}
          </Button>
          <Button
            className={styles.saveButton}
            variant='contained'
            color='secondary'
            onClick={onUpdate}
          >
            <SaveRoundedIcon />
            <Typography className={styles.buttonText}>
              {isDraftMode || !shooting.id ? fmtSaveDraft : fmtSave}
            </Typography>
          </Button>
        </div>

        <Box className={styles.row}>
          <Button className={styles.backButton} variant='outlined' onClick={onPreviousStep}>
            <ChevronLeftRoundedIcon />
            {intl.formatMessage({ id: 'shooting.create.buttons.back' })}
          </Button>

          <Button
            variant='contained'
            color='secondary'
            className={styles.nextButton}
            onClick={onNextStep}
          >
            {`${intl.formatMessage({ id: 'shooting.create.buttons.next' })} (3/5)`}
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default PackageStep;
